import React from "react";
import './SearchSyntaxHint.css';


//SearchSyntaxHint
export default () => {
    return <div 
            className="rioree-hint"
            style={{
                padding: "4px 0",
                fontSize: "0.8em",
            }}
        >
        <div className="rioree-hint-body">
            Boolean operators OR and - are supported.
            You can also search for an exact phrase by wrapping it in double quotation marks.
            e.g. "big data" -review OR vision
        </div>
    </div>;
}